import { useContext, useState, useRef, useEffect } from 'react';
import { AppContext } from '../App';
import { AppContext as MainAppContext } from '../../App';
import logo_wide from '../assets/logo_wide.png';
import ChatView from '../../views/ChatViewOld';
import { AiOutlineSend, AiOutlineClose, AiOutlineArrowDown } from 'react-icons/ai';
import GameChatMessage from '../ones/GameChatMessage';

export default function CoreChatter(props) {

  const app = useContext(AppContext);
  const mainApp = useContext(MainAppContext);
  const [ showBtmBtn, setShowBtmBtn ] = useState(true)
  const [ allMessages, setAllMessages ] = useState(null)
  const messageContainerRef = useRef(null);

  const quickMessages = [
    { text: 'Good luck! 🍀', emoji: '\uD83C\uDF40' },
    { text: 'Nice move! 🎯', emoji: '\uD83C\uDFAF' },
    { text: 'Asante! 😊', emoji: '\uD83D\uDE0A' },
    { text: 'Well played! 👏', emoji: '\uD83D\uDC4F' },
    { text: 'Oops! 🙈', emoji: '\uD83D\uDE48' },
    { text: 'Your turn! 🃏', emoji: '\uD83C\uDCCF' },
    { text: 'Thanks! 😊', emoji: '\uD83D\uDE0A' },
  ];
  
  function scrollToLatestMessage() {
    if(app.gameData) {

      if(allMessages && allMessages.length > 0) {
        if(messageContainerRef.current) {
          messageContainerRef.current.scrollTo({
            //top: scrollPosition,
            top: messageContainerRef.current.scrollHeight,
            behavior: 'smooth'
          });
        }
      }
    }
  }

  function isLastMessageVisible() {
    if(messageContainerRef.current) {
      let maxScrollTop = messageContainerRef.current.scrollHeight - messageContainerRef.current.clientHeight;
      if((messageContainerRef.current.scrollTop + 100) >= maxScrollTop) {
        return true;
      }
    }
    return false;
  }

  function scrollHandler() {
    setShowBtmBtn(!isLastMessageVisible());
  }

  useEffect(() => {
    scrollToLatestMessage();
  }, [])
  
  useEffect(() => {
    if(allMessages) {
      if(allMessages.length > 0) {
        scrollToLatestMessage();
      }
    }
  }, [ allMessages ])

  useEffect(() => {
    if(app.gameData) {
      setAllMessages(JSON.parse(app.gameData.chatMessages))
    }
  }, [ app.gameData ])


  //render
  if(app.gameData) {
    if(app.showChat) {
      return (
        <div
          className='CoreChatter'
        >
          <div className='mTopbar mNoScrollBar'>
            <div className='d-flex justify-content-between' style={{ height: "100%" }}>
              <h6
                style={{
                  marginTop:"0px",
                  marginBottom: "0px",
                  marginLeft: "20px",
                  marginRight: "0px",
                  flexShrink: "0",
                }}
                className='align-self-center core-text-blackish'
              >
                Game Chat
              </h6>

              <AiOutlineClose
                size={25}
                style={{
                  marginTop:"0px",
                  marginBottom: "0px",
                  marginLeft: "0px",
                  marginRight: "20px",
                  cursor: "pointer",
                  flexShrink: "0",
                }}
                onClick={() => {
                  app.setShowChat(false);
                }}
                className='align-self-center core-text-blackish'
              />
            </div>
          </div>

          <div onScroll={scrollHandler} ref={messageContainerRef} className='mMessages mNoScrollBar' id="chat-messages">
            {
              (allMessages && allMessages.length > 0) ?
              allMessages.map((item, i) => {
                return (
                  <GameChatMessage index={i} data={item} key={i}/>
                )
              })
              :
              <h6 className='font-light text-center' style={{ padding: "20px", fontSize: "14px" }}>
                No messages were found
              </h6>
            }
          </div>

          {
            (showBtmBtn) ?
            <button onClick={scrollToLatestMessage} className='btn mBtmBtn'>
              <AiOutlineArrowDown size={20}/><br/>
              <span>Newer</span>
            </button>:""
          }

          <div className='mQuickMsg mNoScrollBar'>
            
            <div
              className='d-flex'
              style={{
                height: "100%",
                width: "auto",
              }}
            >
              
              {
                quickMessages.map((message, index) => {
                  return (
                    <button 
                      key={index} 
                      className='btn coreQuickMsg'
                      onClick={() => {
                        app.sendQuickMessage(message.text)
                      }}
                    >
                      {message.text}
                    </button>
                  );
                })
              }
            </div>
          </div>

          <div
            className='mKeyboard mNoScrollBar d-flex'
          >
            <textarea
              rows="2"
              placeholder="Type here..."
              maxLength={300}
              className='coreTypingBox'
              value={app.chatMessage}
              onChange={(e) => app.setChatMessage(e.target.value)}
            ></textarea>
            <AiOutlineSend
              size={30}
              onClick={app.sendChatMessage}
              className='align-self-center core-text-goldish'
              style={{
                flexShrink: "0",
                margin: "10px",
                cursor: "pointer"
              }}
            />
          </div>
        </div>
      )
    }
  }
}